<div fxLayout="column" fxLayoutAlign="space-between center" class="iwg-login-background" 
        style="height: 100%;" >
    <div style="height: 100%; min-height: 570px;" fxLayout="row" fxLayoutAlign="center center" class="topspace">
        <div  >
        <mat-card layout="column" class="card iwg-access-box">

            <div class="vista-toolbar">
                <span class="vista-request">Request Access</span>
                <span flex></span>
                <button mat-button class="mat-icon-button vista-request-button" [routerLink]="['/login']">
                    <mat-icon class="request-closebutton">close</mat-icon>
                </button>
            </div>

            <mat-progress-bar *ngIf="loading" class="colorChange" mode="indeterminate"></mat-progress-bar>
            <div class="adjustAccess">
                <div class="center">
                    <img class="card-img" src="../../assets/images/myvista-logo.png">
                </div>
                <mat-card-content class="mat-card-align-left">
                    <form id="accessReqForm" name="accessReqForm" #accessReqForm="ngForm">
                        <mat-form-field class="mat-form-field vista-login-label">
                            <mat-label>Company Name </mat-label>
                            <input type="text" matInput [(ngModel)]="companyname" id="companyname" 
                                #companyName = "ngModel" name="companyname" required />
                            <mat-error [hidden]="companyName.valid">Required</mat-error>
                        </mat-form-field>
                        

                        <mat-form-field class="mat-form-field vista-login-label">
                            <mat-label>First Name</mat-label>
                            <input type="text" matInput [(ngModel)]="firstname" #firstName="ngModel" id="firstname" name="firstname" required />
                            <mat-error [hidden]="firstName.valid">Required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="mat-form-field vista-login-label">
                            <mat-label>Last Name</mat-label>
                            <input type="text" matInput [(ngModel)]="lastname" #lastName="ngModel" id="lastname" name="lastname" required />
                            <mat-error [hidden]="lastName.valid">Required</mat-error>
                        </mat-form-field>

                        <mat-form-field class="mat-form-field vista-login-label">
                            <mat-label>Email Address</mat-label>
                            <input matInput type="email" [(ngModel)]="emailaddress" id="emailaddress" name="emailaddress" 
                                [pattern]="emailPattern" #emailAddress="ngModel" />
                            <mat-error [hidden]="emailAddress.valid">Email must be valid</mat-error>
                        </mat-form-field>

                        <mat-form-field class="mat-form-field vista-login-label">
                            <mat-label>Phone Number</mat-label>
                            <input type="text" matInput [(ngModel)]="phonenumber" id="phonenumber" name="phonenumber"
                                [pattern]="phoneNoPattern" required #phoneNumber="ngModel" />
                            <mat-error *ngIf="phoneNumber.hasError('required')">
                                Phone number is Required
                            </mat-error>
                            <mat-error *ngIf="phoneNumber.hasError('pattern')">
                                Phone number must be valid
                            </mat-error>
                        </mat-form-field>
                    </form>
                </mat-card-content>
            </div>
            <div class="vista-button">
                <button flex form="accessReqForm" type="submit" disabled class="buttonAccess mat-button-raised mat-primary"
                    color="light-text" [disabled]="!accessReqForm.form.valid" (click)="submitAccessReq()" ><span >Request Access</span></button>
            </div>
           
            <p class="iwg-login-info backLogin">
                <a [routerLink]="['/login']">Back to Log In</a>
            </p>
        </mat-card>
        </div>
    </div>
    <div class="loginfooter">
        <app-iwg-footer [blurBg]="true"></app-iwg-footer>
    </div>
</div>